import { render, staticRenderFns } from "./StoreTrainingMenuForm.vue?vue&type=template&id=2639042d&"
import script from "./StoreTrainingMenuForm.vue?vue&type=script&lang=js&"
export * from "./StoreTrainingMenuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports